import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function CustomerTestimonials() {
  const testimonials = [{
    name: 'Sarah Jenkins',
    store: 'Midland Store',
    text: "The staff here are incredibly knowledgeable. They helped me find the perfect food for my dog's sensitive stomach when my vet's recommendation didn't work out. Real local service.",
    rating: 5
  }, {
    name: 'Mark Thompson',
    store: 'Malaga Store',
    text: 'I come here for all my pool supplies. They test the water for free and tell me exactly what I need without overselling. Plus they carry the heavy chlorine drums to my car!',
    rating: 5
  }, {
    name: 'Emma Davis',
    store: 'Caversham Store',
    text: 'Best garden center in the area. The seedlings are always healthy and the staff actually know how to fix my soil issues. The Customer Care Club discounts are a huge bonus.',
    rating: 5
  }];
  return <section className="section-padding bg-brand-blue-50/50 border-y border-brand-blue-100" data-id="element-43">
      <div className="container-wide" data-id="element-44">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-45">
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-gray-900 mb-4" data-id="element-46">
            Loved by WA Locals
          </h2>
          <p className="text-lg text-gray-600" data-id="element-47">
            Don't just take our word for it. Here's what our community has to
            say about the Better Pets and Gardens experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-48">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-card relative" data-id="element-49">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-brand-blue-100" data-id="element-50" />
              <div className="flex text-yellow-400 mb-4" data-id="element-51">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-52" />)}
              </div>
              <p className="text-gray-700 mb-6 relative z-10 leading-relaxed" data-id="element-53">
                "{testimonial.text}"
              </p>
              <div className="mt-auto" data-id="element-54">
                <div className="font-heading font-bold text-gray-900" data-id="element-55">
                  {testimonial.name}
                </div>
                <div className="text-sm text-brand-blue font-medium" data-id="element-56">
                  {testimonial.store} Customer
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}